export function ChevronIcon({ expanded }: { expanded: boolean }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="currentColor"
			className={`h-3 w-3 transition-transform ${expanded ? 'rotate-90' : ''}`}
		>
			<path
				fillRule="evenodd"
				d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
				clipRule="evenodd"
			/>
		</svg>
	)
}

export function SettingsIndexIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M6.769 0.174566C6.623442 0.197708 6.512184 0.230594 6.391 0.286314C6.279364 0.337638 1.29122 3.244822 1.140636 3.346322C0.893354 3.512992 0.669956 3.811234 0.5752320000000001 4.101146C0.49957599999999996 4.332706 0.502908 4.1880999999999995 0.507206 7.049L0.5111680000000001 9.695 0.548828 9.819558C0.652904 10.163804 0.872018 10.472616 1.140636 10.653678C1.245832 10.724588 6.2293840000000005 13.634852 6.3519820000000005 13.69697C6.519814 13.782005999999999 6.797644 13.845832000000001 7 13.845832000000001C7.202202 13.845832000000001 7.479024 13.781796 7.651 13.69522C7.7685580000000005 13.636042000000002 12.75414 10.724602 12.859364 10.653678C13.131468 10.470264 13.360228000000001 10.142874 13.455820000000001 9.8L13.489 9.681000000000001 13.489 7L13.489 4.319 13.455820000000001 4.2C13.360228000000001 3.8571260000000005 13.131468 3.529736 12.859364 3.346322C12.754168 3.275412 7.7706159999999995 0.36514800000000003 7.648018 0.30303C7.4021360000000005 0.17844400000000002 7.0596119999999996 0.12838 6.769 0.174566M6.847232000000001 1.18496C6.750366 1.218868 1.723106 4.156768 1.655262 4.219110000000001C1.621872 4.249784 1.5755460000000001 4.314828 1.550262 4.366502L1.5050000000000001 4.4590000000000005 1.5050000000000001 6.993L1.5050000000000001 9.527000000000001 1.53832 9.60967C1.607046 9.780190000000001 1.483216 9.702322 4.251268 11.316032C5.646228000000001 12.129264 6.820058 12.805268 6.85979 12.81826C6.962018 12.851692 7.110978 12.839091999999999 7.21154 12.788482C7.253050000000001 12.767608 8.41155 12.095076 9.786 11.293982C12.513592 9.704226 12.392982 9.780148 12.461680000000001 9.60967L12.495000000000001 9.527000000000001 12.495000000000001 7L12.495000000000001 4.473 12.461680000000001 4.3903300000000005C12.392954 4.219810000000001 12.516672 4.2976220000000005 9.749894000000001 2.684654C8.355592 1.8718 7.18515 1.1966780000000001 7.148904000000001 1.184372C7.066402 1.156358 6.928166000000001 1.156624 6.847232000000001 1.18496M6.678 4.013001999999999C5.976866 4.100096 5.359326 4.3969380000000005 4.878132 4.878132C4.44248 5.313798 4.163082 5.84948 4.042472 6.480376000000001C4.015423999999999 6.621888 4.011392000000001 6.6893400000000005 4.011392000000001 7C4.011392000000001 7.398328 4.027464 7.522256 4.1215019999999996 7.848624C4.399402 8.813153999999999 5.186846 9.600598 6.151376 9.878498C6.477744 9.972536 6.601672 9.988608 7 9.988608C7.398328 9.988608 7.522256 9.972536 7.848624 9.878498C8.812538 9.600766 9.600766 8.812538 9.878498 7.848624C9.972536 7.522256 9.988608 7.398328 9.988608 7C9.988608 6.601672 9.972536 6.477744 9.878498 6.151376C9.600738000000002 5.1873640000000005 8.812818 4.399304 7.8491 4.1216420000000005C7.545425999999999 4.034142 7.407092 4.014962000000001 7.049 4.01072C6.8719 4.00862 6.70495 4.009642 6.678 4.013001999999999M6.808284 5.013330000000001C6.056204 5.080376 5.386388 5.597298 5.1255820000000005 6.311928C4.8545 7.054726 5.047784 7.891996000000001 5.615876 8.435699999999999C6.163514 8.959818 6.935376000000001 9.130968 7.651 8.886948C8.306956000000001 8.663269999999999 8.814777999999999 8.088304 8.952804 7.413C9.09223 6.730836 8.879121999999999 6.038060000000001 8.384124 5.5643C8.040522 5.235468 7.641395999999999 5.054392 7.167734 5.012462C6.991376000000001 4.9968520000000005 6.993056 4.9968520000000005 6.808284 5.013330000000001"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
				strokeWidth={0.014}
			/>
		</svg>
	)
}

export function SettingsExportIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M12.091338 0.022904C11.979379999999999 0.04319 1.178828 3.6392160000000002 0.974862 3.7241260000000005C0.8101240000000001 3.7927120000000003 0.6256740000000001 3.9204900000000005 0.48256600000000005 4.06518C0.160398 4.39089 0.008302 4.769506 0.009422000000000002 5.243C0.010038 5.501426 0.063196 5.728646 0.174874 5.950126C0.279622 6.157886 0.326774 6.208412000000001 1.7060540000000002 7.590702L3.056802 8.944417999999999 3.01455 10.58337C2.987642 11.62658 2.97675 12.250742 2.9845479999999998 12.300512C3.0303839999999997 12.59279 3.358138 12.784688000000001 3.6344559999999997 12.681046C3.6814540000000004 12.66342 4.168878 12.416698 4.717622 12.132764L5.715332 11.616514 6.102166 11.99989C6.3149239999999995 12.210744 6.775650000000001 12.667326 7.126 13.014526C7.47635 13.361712 7.8039499999999995 13.674514 7.854 13.709626C8.025962 13.83025 8.216768 13.912542 8.450652000000002 13.966932C8.5883 13.998936 8.932602000000001 14.00259 9.079 13.973582C9.580858 13.874182000000001 9.98634 13.572902000000001 10.222814000000001 13.123726C10.280494000000001 13.014162 10.600772 12.066292 12.118204 7.514444C13.122508 4.501854 13.954597999999999 1.9897500000000001 13.967296 1.932C13.999076 1.787576 13.99888 1.475054 13.966904 1.3116320000000001C13.88849 0.910756 13.662754 0.557046 13.325984 0.307342C13.203330000000001 0.216412 13.001814000000001 0.11418400000000001 12.859812 0.070882C12.631934 0.0014000000000000002 12.31825 -0.018186 12.091338 0.022904M6.641908000000001 2.8816900000000003C3.746106 3.8493140000000006 1.3526099999999999 4.6536 1.323042 4.6690000000000005C1.293474 4.6844 1.237082 4.729354 1.197742 4.76889C0.9970239999999999 4.970602 0.951734 5.27639 1.08605 5.523C1.113504 5.5734 1.469678 5.939136 2.358496 6.82962L3.59282 8.066253999999999 7.7359100000000005 4.612748000000001C11.767112000000001 1.252496 11.927230000000002 1.11867 11.913496 1.12119C11.909925999999999 1.1218480000000002 9.53771 1.914066 6.641908000000001 2.8816900000000003M8.561 5.2317860000000005C6.1278 7.26068 4.119878 8.934254 4.098948 8.950844L4.0608960000000005 8.981 4.0316920000000005 10.08C4.015634 10.68445 4.004406 11.221196 4.006744 11.272758L4.011 11.366502 4.795 10.96067C5.2262 10.737468 5.6168 10.541804 5.663 10.525872C5.729094 10.503066 5.768266000000001 10.49846 5.84682 10.504242C6.050408000000001 10.519222000000001 5.98339 10.460898 7.266 11.739182000000001C8.354864 12.824364 8.42653 12.89288 8.517516 12.935818C8.683808 13.014274 8.89504 13.01027 9.064244 12.925457999999999C9.166514 12.87419 9.285416000000001 12.753957999999999 9.334738000000002 12.651940000000002C9.357852000000001 12.604116 10.190502 10.122755999999999 11.185076 7.137788C12.888274000000001 2.0261080000000002 12.993162 1.705704 12.9892 1.626744L12.985 1.5428979999999999 8.561 5.2317860000000005"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
				strokeWidth={0.014}
			/>
		</svg>
	)
}

export function BrandingLibraryIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M1.71675 0.525756C1.190532 0.630308 0.75061 1.013824 0.579166 1.51746C0.49903000000000003 1.752884 0.5038600000000001 1.4479780000000002 0.5038039999999999 6.284446C0.503776 9.181802 0.508662 10.770018 0.517832 10.843C0.604982 11.536392000000001 0.8972180000000001 12.140296 1.378468 12.621532C1.859718 13.102796 2.461816 13.394192 3.157 13.48228C3.230654 13.491618 4.791808 13.496336 7.716884 13.496056000000001C11.609976 13.495692 12.178572 13.493032000000001 12.275424000000001 13.47465C12.584138 13.416088 12.850026000000002 13.272336000000001 13.071212000000001 13.044402000000002C13.289346 12.819604 13.417964000000001 12.574254 13.474832000000001 12.2745C13.506584 12.10713 13.506584 8.89287 13.474832000000001 8.7255C13.374312 8.195586 12.990348 7.7520240000000005 12.48254 7.579166000000001C12.273800000000001 7.508116 12.216344 7.5040000000000004 11.43317 7.5040000000000004L10.703434 7.5040000000000004 11.733568 6.4715C12.780712000000001 5.421962000000001 12.825232 5.373424 12.927124000000001 5.170382C13.054062 4.917458 13.107682 4.62273 13.076839999999999 4.3474900000000005C13.047468 4.085466 12.975731999999999 3.8879120000000005 12.830076 3.668C12.75246 3.550806 12.604214 3.3976040000000003 11.582494 2.378796C10.847858 1.646232 10.393586 1.203566 10.34271 1.1706800000000002C9.961084 0.923986 9.524074 0.85246 9.1 0.967274C8.95839 1.005606 8.758652000000001 1.101968 8.627164 1.1953900000000002C8.553188 1.24796 8.202572 1.588958 7.518042 2.274132C6.967506 2.825158 6.512338 3.2760000000000002 6.506542 3.2760000000000002C6.500746 3.2760000000000002 6.496 2.9522500000000003 6.496 2.55654C6.496 1.78451 6.491758 1.725822 6.420834 1.51746C6.273512 1.084678 5.915322000000001 0.726488 5.48254 0.579166C5.256692 0.502292 5.299938 0.503888 3.4879599999999997 0.505316C2.132578 0.50638 1.7946319999999998 0.510286 1.71675 0.525756M1.9077800000000003 1.512588C1.747284 1.544732 1.59768 1.6673440000000002 1.537746 1.8158420000000002L1.5050000000000001 1.897 1.50108 3.1955L1.497174 4.494 3.5 4.494L5.502826000000001 4.494 5.49892 3.1955L5.495 1.897 5.46189 1.81489C5.417076000000001 1.70373 5.29627 1.582924 5.18511 1.5381099999999999L5.103 1.5050000000000001 3.535 1.502858C2.6726 1.5016820000000002 1.940344 1.50605 1.9077800000000003 1.512588M9.359 1.9369C9.328199999999999 1.947008 9.280949999999999 1.966482 9.254 1.980146C9.22705 1.993824 8.598632 2.6105940000000003 7.8575 3.35076L6.51 4.696524 6.510028 7.489762L6.51007 10.283 9.253440000000001 7.539000000000001C12.347006 4.44472 12.075000000000001 4.737586 12.075000000000001 4.501C12.075000000000001 4.2716520000000004 12.148892 4.359068000000001 10.894912 3.1050880000000003C9.659328 1.869504 9.728838000000001 1.929298 9.52 1.9221160000000002C9.46071 1.920072 9.390626000000001 1.926512 9.359 1.9369M1.498 6.748L1.498 7.994 3.493 7.994L5.488 7.994 5.488 6.748L5.488 5.502 3.493 5.502L1.498 5.502 1.498 6.748M7.7898380000000005 10.419178C6.068314000000001 12.143096 5.7540000000000004 12.463374 5.7540000000000004 12.493628000000001C5.7540000000000004 12.49843 7.182518000000001 12.500698000000002 8.9285 12.498682L12.103 12.495000000000001 12.18511 12.46189C12.240998 12.43935 12.293008 12.402992 12.348 12.348C12.402992 12.293008 12.43935 12.240998 12.46189 12.18511L12.495000000000001 12.103 12.495000000000001 10.5L12.495000000000001 8.897 12.46189 8.81489C12.417076 8.70373 12.29627 8.582924 12.18511 8.53811L12.103 8.505 10.906 8.501178L9.709 8.497356 7.7898380000000005 10.419178M1.498126 9.7545C1.4981820000000001 10.168382 1.504636 10.579338 1.512462 10.667734C1.5480639999999999 11.07001 1.680742 11.409384000000001 1.925798 11.725C2.457826 12.41023 3.3615120000000003 12.668488000000002 4.188828 12.371716C4.742668 12.173056 5.201014 11.702026 5.388166000000001 11.139198C5.485087999999999 10.84769 5.487874 10.81178 5.487944 9.852500000000001L5.488 9.002 3.493 9.002L1.498 9.002 1.498126 9.7545"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
				strokeWidth={0.014}
			/>
		</svg>
	)
}

export function AssetHubIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M1.33 1.009848C0.763868 1.070188 0.26658800000000005 1.4706860000000002 0.079198 2.0172040000000004C-0.0056700000000000006 2.264738 -0.000644 1.9304599999999998 0.003514 7.056014C0.007308 11.72633 0.007392 11.73928 0.035994000000000005 11.844C0.142338 12.233382 0.35636999999999996 12.539338 0.668976 12.748876000000001C0.8186640000000001 12.8492 1.040788 12.940871999999999 1.230796 12.980744000000001C1.3386660000000001 13.003368 12.39014 13.014498 12.628 12.99221C12.866798000000001 12.969838000000001 13.074684 12.903996000000001 13.265 12.790428C13.631786 12.57158 13.906676 12.179300000000001 13.97235 11.781C13.98124 11.7271 13.994246 11.672066000000001 14.00126 11.658696C14.008862 11.644178 14.012628000000001 9.756236000000001 14.010598 6.975696C14.008722 4.413416000000001 14.004984 2.77375 14.002296 3.332C13.997816 4.2591920000000005 13.995674000000001 4.33748 13.977558 4.23696C13.92363 3.9376819999999997 13.77383 3.6535800000000003 13.555682000000001 3.436846C13.315442 3.1981740000000003 13.015548 3.053008 12.677 3.0115260000000004C12.588674000000001 3.00069 11.630206000000001 2.99607 9.470972000000002 2.9960419999999996L6.39093 2.996 6.266918 2.5025C6.19871 2.2310820000000002 6.122522 1.961064 6.0976159999999995 1.9024599999999998C5.941642000000001 1.535576 5.599398 1.215984 5.220656 1.083558C4.9794920000000005 0.9992359999999999 5.07787 1.003268 3.185 1.000076C2.221086 0.998452 1.39608 1.002806 1.33 1.009848M1.371006 2.021026C1.232294 2.058672 1.1136300000000001 2.158856 1.04657 2.2949360000000003L1.0150000000000001 2.359 1.0150000000000001 7L1.0150000000000001 11.641 1.0493979999999998 11.711C1.0957240000000001 11.805248 1.200948 11.90756 1.298696 11.953368000000001L1.379 11.991 7 11.991L12.621 11.991 12.701304 11.953368000000001C12.798002 11.908036 12.902288 11.806410000000001 12.950000000000001 11.711L12.985 11.641 12.988612000000002 8.019312C12.992196 4.418134 12.992056 4.39719 12.964 4.322192C12.913879999999999 4.188268 12.77486 4.061456 12.633376 4.020632C12.589626 4.008004 11.778970000000001 4.003916 9.266376000000001 4.003664C7.1337 4.003439999999999 5.935636 3.998386 5.896926000000001 3.9894540000000003C5.747084 3.9548880000000004 5.608414 3.84615 5.549474 3.717C5.531904000000001 3.6785 5.444502 3.35405 5.355238 2.996C5.26596 2.63795 5.177298 2.3126040000000003 5.158174 2.273012C5.115025999999999 2.183636 5.020638 2.0950860000000002 4.91645 2.04624L4.837 2.009 3.136 2.0063400000000002C1.8190479999999998 2.004268 1.420552 2.007586 1.371006 2.021026M0.006916 7C0.006916 9.56795 0.008526 10.618468 0.0105 9.3345C0.012474 8.050518 0.012474 5.9494679999999995 0.0105 4.6655C0.008526 3.3815180000000002 0.006916 4.43205 0.006916 7M5.317802 5.535236C5.20695 5.580833999999999 5.1051 5.670462000000001 5.054056 5.767356C4.9980139999999995 5.873714 4.998336 5.860988 4.998168 8.001952C4.997986 10.284638 4.992134 10.139458 5.090078 10.284232C5.209078 10.460086 5.453952 10.544506 5.6510299999999996 10.477586C5.754952 10.442306 9.265746000000002 8.430548 9.335494 8.366316000000001C9.453346 8.257774 9.515982 8.098272 9.498804 7.950362000000001C9.486862 7.847448000000001 9.425402 7.717318 9.356298 7.648634C9.292793999999999 7.585508 5.724054 5.5416620000000005 5.635 5.5174C5.539716 5.491458000000001 5.40596 5.498976 5.317802 5.535236M6.006 8.001826C6.006 8.622124 6.010718 9.127104000000001 6.0165 9.123996000000002C6.304172 8.969016 7.977718 8.00037 7.970059999999999 7.993272C7.957208 7.9813719999999995 6.0193140000000005 6.8740000000000006 6.011334 6.8740000000000006C6.008408 6.8740000000000006 6.006 7.381527999999999 6.006 8.001826"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
				strokeWidth={0.014}
			/>
		</svg>
	)
}

export function BillingIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M1.26 1.519168C1.102444 1.5466360000000001 0.9740920000000001 1.590764 0.822542 1.669584C0.399868 1.889398 0.103684 2.3022020000000003 0.022260000000000002 2.784964C0.002268 2.903502 0 3.3327000000000004 0 7C0 10.667300000000001 0.002268 11.096498 0.022260000000000002 11.215036C0.05980800000000001 11.437664 0.1456 11.653096000000001 0.26996200000000004 11.837C0.5052180000000001 12.184928 0.8863679999999999 12.426008 1.297688 12.487062C1.4393120000000001 12.508075999999999 12.560688 12.508075999999999 12.702312000000001 12.487062C13.113646 12.426008 13.494866 12.184872 13.730024 11.837C13.850088000000001 11.659382 13.941704 11.432456 13.973064 11.235C13.98285 11.1734 13.996066 11.117008 14.002436 11.1097C14.017234 11.092690000000001 14.017738000000001 2.866038 14.00294 2.8751800000000003C13.99685 2.878946 13.983801999999999 2.8307860000000002 13.973946 2.76815C13.942768000000001 2.569938 13.850676 2.341472 13.730024 2.1630000000000003C13.494866 1.8151279999999999 13.113646 1.573992 12.702312000000001 1.512938C12.54092 1.4889839999999999 1.398376 1.49506 1.26 1.519168M1.3349980000000001 2.535148C1.2026000000000001 2.5860659999999998 1.082886 2.717372 1.034138 2.865114C1.009582 2.939566 1.008 3.006318 1.008 3.97117L1.008 4.998 7 4.998L12.992 4.998 12.992 3.97117C12.992 3.006318 12.990418 2.939566 12.965862000000001 2.865114C12.916386000000001 2.715132 12.796574000000001 2.585184 12.66104 2.534462C12.584992 2.506014 12.582108 2.5060000000000002 6.995968 2.506728C1.462188 2.5074560000000004 1.406286 2.507736 1.3349980000000001 2.535148M0.006902 7C0.006902 9.26765 0.008526 10.195318 0.0105 9.0615C0.012474 7.927668 0.012474 6.072318 0.0105 4.9385C0.008526 3.804668 0.006902 4.732349999999999 0.006902 7M1.008 8.53083C1.008 10.958164 1.0090080000000001 11.058712 1.034138 11.134886000000002C1.083614 11.284868000000001 1.203426 11.414816 1.33896 11.465538C1.414994 11.493986000000001 1.4188020000000001 11.494 7 11.494C12.581198 11.494 12.585006 11.493986000000001 12.66104 11.465538C12.796574000000001 11.414816 12.916386000000001 11.284868000000001 12.965862000000001 11.134886000000002C12.990992 11.058712 12.992 10.958164 12.992 8.53083L12.992 6.006 7 6.006L1.008 6.006 1.008 8.53083M9.376276 8.51298C9.242925999999999 8.545054 9.107 8.659672 9.045428 8.791972000000001C8.993866 8.902768 8.98793 9.061962000000001 9.031092 9.176944C9.073344 9.289546 9.183496000000002 9.405004 9.300032 9.458834L9.387 9.499 10.183712 9.503256C10.662568 9.505804 11.015914 9.501982 11.069379999999999 9.493652C11.243371999999999 9.466562 11.379410000000002 9.364502 11.454002000000001 9.205098C11.489716 9.128798 11.49617 9.098152 11.495974 9.005962C11.495526 8.791426 11.394544 8.632876 11.200000000000001 8.541260000000001L11.123000000000001 8.505 10.276 8.502648C9.808932 8.501346 9.405354 8.505980000000001 9.376276 8.51298"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
				strokeWidth={0.014}
			/>
		</svg>
	)
}

export function WalletIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
			/>
		</svg>
	)
}

export function InventoryIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
			/>
		</svg>
	)
}

export function InvoicesIcon({ className = 'h-4' }: { className?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className={className}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm-2.25 12 1.5 1.5 3-3"
			/>
		</svg>
	)
}

export function OrganizationIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
			/>
		</svg>
	)
}

export function PrivacyIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
			/>
		</svg>
	)
}

export function WhatsAppIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
			/>
		</svg>
	)
}

export function ProfilesIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0ZM10.5 15.75a3 3 0 0 0-6 0v.75h6v-.75Z"
			/>
		</svg>
	)
}

export function EmailTemplatesIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
			/>
		</svg>
	)
}

export function CustomFieldsIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
			/>
		</svg>
	)
}

export function DesignSimulatorIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42"
			/>
		</svg>
	)
}

export function AdDesignsIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
			/>
		</svg>
	)
}

export function CareerSiteIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5a17.92 17.92 0 0 1-8.716-2.247m0 0A8.966 8.966 0 0 1 3 12c0-1.264.26-2.467.732-3.558"
			/>
		</svg>
	)
}

export function AiSettingsIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
			/>
		</svg>
	)
}

export function MembersIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
			/>
		</svg>
	)
}

export function CandidateCenterIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
			/>
		</svg>
	)
}

export function CampaignSettingsIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
			/>
		</svg>
	)
}
